import enUS from './en_us';
import frFR from './fr_fr';

export const LANG_DEFAULT = 'en_us';
export const lang_available = [
    enUS, frFR
];
export const dictionaries = {};

for (const idx in lang_available) {
    const lang = lang_available[idx];
    dictionaries[lang.name.toLowerCase()] = lang.dictionary;
}

export default {
    default: LANG_DEFAULT,
    ...dictionaries
};